export const isClientError = errorStatus => Math.floor(errorStatus / 100) === 4;
